"use strict";

const ScenariosLayer = function () {
  const MapLayer = require("../mapFunctions/mapLayer");

  const layerName = "scenarios";
  const layerKey = "scenariosLayer";

  const scenariosLayer = new MapLayer(layerName, layerKey, null, {
    clusteringEnabled: true,
    itemCountEnabled: true,
  });

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    scenariosLayer.loadToggledListenerForMap(map, mapLayers, mapId);
    scenariosLayer.loadDataUpdatedListenerForMap(map, mapLayers, mapId);
    if (mapId === "main") {
      scenariosLayer.loadTreeUpdateListenersForMap(map, mapLayers);
    }
  };

  return {
    ...scenariosLayer,
    loadLayerListenersForMap,
  };
};

module.exports = ScenariosLayer();
